/**
 * Límites duros del motor (05-arquitectura-tecnica.md y 08-seguridad-privacidad.md):
 * tamaño, profundidad, cantidad y tiempo. Se aplican ANTES de generar la matriz
 * para evitar que un documento hostil o desproporcionado bloquee el hilo principal.
 */
export const LIMITS = {
  /** Profundidad máxima de anidación aceptada al recorrer el documento OpenAPI. */
  maxDocumentDepth: 12,
  /** Número máximo de rutas (`paths`) que se procesan. */
  maxPaths: 60,
  /** Número máximo de operaciones (método + ruta) que se procesan. */
  maxOperations: 200,
  /** Máximo de hallazgos visibles, alineado con contracts/output.schema.json (maxItems). */
  maxFindings: 1000,
  /** Presupuesto de tiempo de ejecución del motor antes de abortar (ms). */
  maxRunDurationMs: 5000,
  /** Tamaño máximo de exportación en bytes (5 MB, según 06-modelo-datos.md). */
  maxExportBytes: 5 * 1024 * 1024,
} as const;

export function measureDepth(value: unknown, depth = 0): number {
  if (depth > LIMITS.maxDocumentDepth + 1) return depth;
  if (Array.isArray(value)) {
    let max = depth;
    for (const item of value as unknown[]) {
      max = Math.max(max, measureDepth(item, depth + 1));
    }
    return max;
  }
  if (value !== null && typeof value === "object") {
    let max = depth;
    for (const item of Object.values(value as Record<string, unknown>)) {
      max = Math.max(max, measureDepth(item, depth + 1));
    }
    return max;
  }
  return depth;
}
